module.exports = __webpack_public_path__ + "static/img/page1-fav.9c2d7988.png";